export default __webpack_public_path__ + "static/media/feature5.5a4f9339.png";